/* src/app/dialogs/visual-article-picker/visual-article-picker.component.css */
.d-flex {
  margin-bottom: 10px;
  margin-top: 10px;
}
.d-flex p {
  margin: 0px;
}
.mat-mdc-card-title {
  margin-right: 20px;
}
.row > div > mat-card {
  margin-bottom: 15px;
  height: calc(100% - 15px);
}
.info {
  margin-top: -8px;
  display: block;
  position: absolute;
  right: 10px;
}
.newBox {
  height: 30px;
  margin-top: -40px;
}
.new {
  background-color: #ff4081;
  color: white;
  font-size: 20px;
  animation-name: pulse;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  position: absolute;
  right: 10px;
}
.imageBox {
  overflow: hidden;
  text-align: center;
  height: 200px;
}
.imageBox img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
button.mat-mdc-icon-button {
  width: 24px;
  height: 24px;
  margin-top: -5px;
  border-radius: 50%;
}
button.mat-mdc-icon-button .mat-icon {
  top: 0;
  left: 0;
  position: absolute;
}
.msgbox {
  cursor: pointer;
  border-radius: 10px;
  text-align: center;
}
.out-of-stock {
  border-left: 3px solid #dc3545;
}
@keyframes pulse {
  0% {
    padding: 5px;
  }
  50% {
    padding: 7px;
  }
  100% {
    padding: 5px;
  }
}
.qty-minimal-input {
  width: 40px;
  height: 30px;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 16px;
  outline: none;
  display: inline-block;
  vertical-align: middle;
  padding: 0;
  margin: 0 4px;
}
.qty-minimal-input::-webkit-outer-spin-button,
.qty-minimal-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.qty-minimal-input[type=number] {
  -moz-appearance: textfield;
}
@media screen and (min-width: 0px) {
  .article-column.col-sm-2 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (min-width: 650px) {
  .article-column.col-sm-2 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media screen and (min-width: 950px) {
  .article-column.col-sm-2 {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
}
@media screen and (min-width: 1250px) {
  .article-column.col-sm-2 {
    flex: 0 0 25%;
    max-width: 25%;
  }
}
@media screen and (min-width: 1650px) {
  .article-column.col-sm-2 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
@media screen and (min-width: 1925px) {
  .article-column.col-sm-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
}
@media screen and (min-width: 2250px) {
  .article-column.col-sm-2 {
    flex: 0 0 14.285%;
    max-width: 14.285%;
  }
}
/*# sourceMappingURL=visual-article-picker.component-RQD4VQBT.css.map */
